import React from 'react'

function Header() {
    return (<header>
            <p>LCM/GCD Calculator</p>
        </header>)
}
export default Header